import { createFileRoute } from "@tanstack/react-router";
import { LayoutAuth } from "#/layouts/layout.auth";

// Public contact page (portal's top-level `contact` route).
export const Route = createFileRoute("/$locale/{-$schoolyear}/contact")({
  component: ContactPage,
});

function ContactPage() {
  return (
    <LayoutAuth>
      <h1>Contact</h1>
    </LayoutAuth>
  );
}
